import { RpmStatus } from './types/rpms.types';

export function isClaimCreatedSuccessfully(status: string) {
  return [RpmStatus.CREATED, RpmStatus.CREATED_WITH_WARNINGS].includes(status as RpmStatus);
}
